import styled from 'styled-components';
import { token } from '@bynder/design-system';

export const FloatingContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	float: right;
	height: 60px;
	margin-right: ${token.spacing3};
`;

export const StyledNotificationDescription = styled.span`
	display: -webkit-box;
	max-width: 292px;
	-webkit-line-clamp: 4;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: normal;
`;
